import React, { useEffect, useState } from "react"
import { Task, ViewMode, Gantt } from "gantt-task-react"
import "gantt-task-react/dist/index.css"
import { useAppSelector } from "../../../util/hooks"
import { IGantChartSeriesDataType } from "../../../util/interface"
import { gantChartDataSelector } from "../MonitorSlice"
import { MONTHS, initTasks } from "../../../util/StaticData"
import { theme } from "../../../util/theme"
import { subMonths } from "date-fns"

import { TaskListHeaderDefault } from "./TaskListHeaderDefault"
import { StandardTooltipContent } from "./TooltipContent"
import { TaskListTableDefault } from "./TaskListTableDefault"

const GantChart = ({ viewMode }: any) => {
  // Initialize state for tasks and checked status
  const [tasks, setTasks] = React.useState<Task[]>(initTasks())
  const [isChecked] = React.useState(true)

  // Get month and year filters from Redux store
  const monthSelectedValue = useAppSelector(
    (store) => store.filters.monthSelectedValue,
  )
  const yearSelectedValue = useAppSelector(
    (store) => store.filters.yearSelectedValue,
  )

  // Set the initial view date based on selected month and year
  const [viewDate, setViewDate] = useState(
    new Date(
      Number(yearSelectedValue),
      MONTHS.indexOf(monthSelectedValue as any),
      1,
    ),
  )

  // Define column width based on view mode
  let columnWidth = 65
  if (viewMode === ViewMode.Year) {
    columnWidth = 350
  } else if (
    viewMode === ViewMode.Month ||
    viewMode === ViewMode.Week ||
    viewMode === ViewMode.Day
  ) {
    columnWidth = 200
  }

  // Get Gantt chart series data from Redux store
  const gantSeries: IGantChartSeriesDataType[] = useAppSelector(
    gantChartDataSelector,
  )

  // Update tasks and view date when gantSeries or viewMode changes
  useEffect(() => {
    let finalTasks: any = []

    gantSeries.map((obj) => {
      obj?.data.map((run) => {
        finalTasks.push({ ...run })
      })
    })

    finalTasks = finalTasks.map((task: Task) => {
      const currentDate = new Date()
      if (task.type == "project" && viewMode == ViewMode.Month) {
        task.start = subMonths(
          new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
          1,
        )
        task.end = subMonths(
          new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
          1,
        )
      }

      return {
        ...task,
        start: new Date(task.start),
        end: new Date(task.end),
      }
    })
    setTasks(finalTasks)
    setViewDate(
      new Date(
        Number(yearSelectedValue),
        MONTHS.indexOf(monthSelectedValue as any),
        1,
      ),
    )
  }, [gantSeries, viewMode])

  // Update view date when viewMode changes
  useEffect(() => {
    setViewDate(
      new Date(
        Number(yearSelectedValue),
        MONTHS.indexOf(monthSelectedValue as any),
        1,
      ),
    )
  }, [viewMode])

  // Handle expander click for Gantt chart tasks
  const handleExpanderClick = (task: Task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)))
  }

  return (
    <div className="Wrapper">
      {tasks.length ? (
        <Gantt
          tasks={tasks}
          viewMode={viewMode}
          viewDate={viewDate}
          todayColor="#F8BEBE"
          onClick={() => {}}
          onSelect={() => {}}
          onExpanderClick={handleExpanderClick}
          TaskListHeader={TaskListHeaderDefault}
          TooltipContent={StandardTooltipContent}
          TaskListTable={TaskListTableDefault}
          preStepsCount={1}
          listCellWidth={isChecked ? "155px" : ""}
          ganttHeight={400}
          columnWidth={columnWidth}
          fontFamily={theme.primaryFontFamily}
        />
      ) : (
        ""
      )}
    </div>
  )
}

export default GantChart
